import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { RemediableFailureKind } from './remediableFailureKind';

export const FAILURE_REMEDIATION_PLAN_QUERY_KEY = 'failureRemediationPlan';

export function useGetFailureRemediationPlan(kind: RemediableFailureKind) {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  return useQuery({
    queryKey: [FAILURE_REMEDIATION_PLAN_QUERY_KEY, { tenantId, kind }],
    queryFn: () => api.failures.getFailureRemediationPlan({ tenantId, kind }),
    select: response => response.data,
    enabled: !!tenantId,
    gcTime: 0,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
